export default "__VITE_ASSET__496b2176__"